import React from "react";

export function SystemReportsPage() {
  return (
    <div className="page-container">
      <div className="content">
        <h1>📈 System Reports</h1>
        <p>View system-wide reports, compliance documents, and financial summaries.</p>
        <p style={{ color: "#7f8c8d", marginTop: "20px", fontSize: "14px" }}>
          Coming soon...
        </p>
      </div>
    </div>
  );
}
